import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import {
    Route,
    Routes,
    unstable_HistoryRouter as HistoryRouter,
} from 'react-router-dom'

import i18next from './i18n/config'
import history from './router/CustomHistory'
import App from './App'

import './styles/styles.scss'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
    <I18nextProvider i18n={i18next}>
        <HistoryRouter history={history}>
            <Routes>
                <Route path="*" element={<App />} />
            </Routes>
        </HistoryRouter>
    </I18nextProvider>
)
